import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = ["src"];
const _hoisted_2 = {
    key: 0,
    class: "text"
};
const _hoisted_3 = {
    key: 1,
    class: "text"
};
const _hoisted_4 = ["src"];
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SpendingPotButton',
    props: {
        amount: {}
    },
    emits: ["click"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const formattedAmount = computed(() => {
            return new Intl.NumberFormat('en-GB', {
                style: 'currency',
                currency: 'GBP'
            }).format(props.amount ?? 0);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "spending-pot-button",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (emit('click', $event)), ["stop", "prevent"]))
            }, [
                _createElementVNode("img", {
                    src: require('@/assets/icons/coins-swap-green.png'),
                    alt: "coins",
                    class: "icon"
                }, null, 8, _hoisted_1),
                ((_ctx.amount ?? 0) > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                        _cache[1] || (_cache[1] = _createTextVNode("You have ")),
                        _createElementVNode("b", null, _toDisplayString(formattedAmount.value), 1),
                        _cache[2] || (_cache[2] = _createTextVNode(" in your ")),
                        _cache[3] || (_cache[3] = _createElementVNode("b", null, "Saved", -1)),
                        _cache[4] || (_cache[4] = _createTextVNode(" pot"))
                    ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_3, _cache[5] || (_cache[5] = [
                        _createTextVNode("Find out how you can "),
                        _createElementVNode("b", null, "save", -1),
                        _createTextVNode(" when you "),
                        _createElementVNode("b", null, "spend", -1)
                    ]))),
                _createElementVNode("img", {
                    src: require('@/assets/arrow-right.png'),
                    alt: "arrow",
                    class: "arrow"
                }, null, 8, _hoisted_4)
            ]));
        };
    }
});
